import { render, staticRenderFns } from "./Fund-GeneralSituation.vue?vue&type=template&id=b9be972c&scoped=true&"
import script from "./Fund-GeneralSituation.vue?vue&type=script&lang=js&"
export * from "./Fund-GeneralSituation.vue?vue&type=script&lang=js&"
import style0 from "./Fund-GeneralSituation.vue?vue&type=style&index=0&id=b9be972c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9be972c",
  null
  
)

export default component.exports